import { render, staticRenderFns } from "./barra-lateral-treggo.vue?vue&type=template&id=33dee6f5&scoped=true&"
import script from "./barra-lateral-treggo.vue?vue&type=script&lang=ts&"
export * from "./barra-lateral-treggo.vue?vue&type=script&lang=ts&"
import style0 from "./barra-lateral-treggo.vue?vue&type=style&index=0&id=33dee6f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dee6f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VDivider,VIcon,VRow,VSpacer,VTextField})
